import { dateFormatter } from './dateFormatter'

// Helper function to convert to unix time
export function convertToISODate(value) {
  const formatterDate = dateFormatter(value)
  return new Date(formatterDate).toISOString()
}
